<template>
  <v-container fluid class="testimonials-body">
    <h2 class="my-4 text-center">What do people say?</h2>
    <v-row justify="center">
      <v-col cols="12" md="4" class="d-none d-md-block">
        <v-img
          v-if="whitelabel.images.homeTestatimonial1"
          :src="require(`@/assets/${whitelabel.images.homeTestatimonial1}`)"
          alt="Photo of testimonial 1"
          title="Testimonial 1"
          class="carousel-img mt-2 mx-auto"
        />
        <p class="testimonial-text mt-4 mx-auto text-center">
          "{{ whitelabel.testimonialText1 }}"
          <span class="testimonial-name">
            <br>-- {{ whitelabel.testimonialName1 }}</span>
        </p>
      </v-col>
      <v-col cols="12" md="4">
        <v-img
          v-if="whitelabel.images.homeTestatimonial2"
          :src="require(`@/assets/${whitelabel.images.homeTestatimonial2}`)"
          alt="Photo of testimonial 2"
          title="Testimonial 2"
          class="carousel-img mt-2 mx-auto"
        />
        <p class="testimonial-text mt-4 mx-auto text-center">
          "{{ whitelabel.testimonialText2 }}"
          <span class="testimonial-name">
            <br>-- {{ whitelabel.testimonialName2 }}
          </span>
        </p>
      </v-col>
      <v-col cols="12" md="4" class="d-none d-md-block">
        <v-img
          v-if="whitelabel.images.homeTestatimonial3"
          :src="require(`@/assets/${whitelabel.images.homeTestatimonial3}`)"
          alt="Photo of testimonial 3"
          title="Testimonial 3"
          class="carousel-img mt-2 mx-auto"
        />
        <p class="testimonial-text mt-4 mx-auto text-center">
          "{{ whitelabel.testimonialText3 }}"
          <span class="testimonial-name">
            <br>-- {{ whitelabel.testimonialName3 }}
          </span>
        </p>
      </v-col>
    </v-row>
    <v-row v-if="whitelabel.showTrustpilot">
      <v-col cols="12" md="6" offset-md="3" class="text-center">
        <Trustpilot />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Trustpilot from './Trustpilot.vue'

export default {
  name: 'HomePageTestimonials',
  components: {
    Trustpilot
  }
}
</script>

<style scoped lang="scss">

.testimonials-body {
  background-color: var(--v-background-grey-base);
}

h2 {
  font-size: 40px;
}

.carousel-img {
  max-height: 150px;
  max-width: 150px;
  margin: auto;
  display: block;
}

.testimonial-text {
  font-size: 14px;
  width: 75%;
}

.testimonial-name {
  font-weight: bold;
  font-style: italic;
}
</style>